import script from "./LeftSidebarCompetition.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftSidebarCompetition.vue?vue&type=script&setup=true&lang=js"

import "./LeftSidebarCompetition.vue?vue&type=style&index=0&id=7a797c67&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a797c67"]])

export default __exports__